import ResetPasswordFail from "./resetPasswordFail";

const ResetPassword = () => {

    return (
        <div className='main'>
            <div className='content-area'>
                <div className='container'> 
                <ResetPasswordFail></ResetPasswordFail>
                
                </div>
            </div>
        </div>
    )
};

export default ResetPassword;
